import { render, staticRenderFns } from "./DomainNotFound.vue?vue&type=template&id=c3db439a&"
import script from "./DomainNotFound.vue?vue&type=script&lang=js&"
export * from "./DomainNotFound.vue?vue&type=script&lang=js&"
import style0 from "./DomainNotFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports